/* Tysk katalog for locale-purchases-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'buy.remove': 'Entfernen',
  'buy.openPreview': 'Vorschau öffnen',
  'buy.noPreview': 'Keine Vorschau',
  'buy.savedInBackend': 'Der Beleg ist gespeichert.',
  'buy.open': 'Öffnen',
  'buy.addMoreDocs': 'Weitere Belege hinzufügen',
  'buy.addMoreDocsHelp': 'Füge demselben Einkauf weitere Quittungen oder Seiten hinzu. Alle angehängten Belege werden hier aufgelistet.',
  'buy.uploadDoc': 'Beleg hochladen',
  'buy.uploadDocHelp': 'Hänge die Quittung oder Rechnung für den Einkauf an. Du kannst eine Datei hineinziehen, sie vom Computer auswählen oder einen Beleg aus dem Posteingang holen.',
  'buy.dropOrPick': 'Beleg ablegen oder auswählen',
  'buy.storedIn': 'PDF oder Bild wird in Firebase/im Posteingang gespeichert.',
  'buy.fromInbox': 'Aus Posteingang holen',
  'buy.attachments': 'Anhänge',
  'buy.pickFiles': 'Dateien auswählen',
  'buy.dropAttachments': 'Anhänge hier ablegen',
  'buy.attachmentsNote': 'Anhänge werden beim Speichern der Buchung ins Backend hochgeladen.',
  'buy.supplierSearch': 'Lieferant suchen oder hinzufügen...',
  'buy.supplierSearchShort': 'Lieferant suchen oder hinzufügen',
  'buy.supplierClose': 'Lieferantenauswahl schließen',
  'buy.supplierNone': 'Keine Lieferanten gefunden.',
  'buy.supplierNew': 'Neuer Lieferant',
  'buy.name': 'Name',
  'buy.org': 'Org.-Nr.',
  'buy.email': 'E-Mail',
  'buy.phone': 'Telefon',
  'buy.accountClose': 'Kontoauswahl schließen',
  'buy.searchShort': 'Suchen ...',
  'buy.noAccountMatch': 'Kein Konto entspricht der Suche.',
  'buy.fromInboxRead': 'Aus dem Posteingang geholt - SuperPlumma hat ausgelesen, was möglich war.',
  'buy.docHelp': 'Der Beleg ist die Quittung oder Rechnung, die den Einkauf dokumentiert. Zieh ein Bild oder PDF hinein - oder tippe, um eine Datei auszuwählen. SuperPlumma liest Datum, Betrag, Lieferant und MwSt. aus und schlägt vor, wie der Einkauf gebucht werden soll.',
  'buy.dropReceipt': 'Quittung hier ablegen',
  'buy.dropReceiptHelp': 'Hol den Beleg aus deinen Dateien oder wähle „Aus Posteingang holen“, um einen Beleg zu verwenden, der bereits per E-Mail eingegangen ist. SuperPlumma liest den Inhalt automatisch aus.',
  'buy.upload': 'Hochladen',
  'buy.type': 'Art des Einkaufs',
  'buy.typeHelp': 'Wähle, wie der Einkauf erfasst werden soll. „Bezahlter Einkauf“ ist ein bereits bezahlter Einkauf. „Lieferantenrechnung“ wird verwendet, wenn die Rechnung später bezahlt wird oder teilweise bezahlt ist (wird zu Lieferantenverbindlichkeiten). „Entwürfe“ zeigt begonnene Einkäufe, die du noch nicht gebucht hast.',
  'buy.description': 'Beschreibung',
  'buy.descriptionPh': 'Z. B. Abonnement oder Reise',
  'buy.toggleVat': 'Zwischen exkl. und inkl. MwSt. wechseln',
  'buy.amountExInc': 'Betrag exkl./inkl. MwSt.',
  'buy.amountExIncHelp': 'Tippe, um zu wechseln, ob du den Betrag ohne MwSt. (netto) oder mit MwSt. (brutto) eingibst. Plumme rechnet automatisch zwischen beiden um. „Exkl. MwSt.“ ist die eigentliche Kostenposition, „inkl. MwSt.“ der Gesamtbetrag, den du bezahlt hast.',
  'buy.vatRate': 'MwSt.-Satz',
  'buy.vatRateHelp': 'Der MwSt.-Satz des Einkaufs. 25 % ist der Normalsatz, 15 % gilt für Lebensmittel, 12 % u. a. für Personenbeförderung und Übernachtung, und 0 % wird für steuerfreie Einkäufe verwendet. Die MwSt. auf einen Einkauf ist Vorsteuer, die du abziehen kannst.',
  'buy.pickCategory': 'Konto/Kategorie',
  'buy.category': 'Kategorie',
  'buy.categoryHelp': 'Um welche Art von Kosten es sich handelt. Die Kategorie bestimmt, auf welches Konto der Einkauf gebucht wird, damit er korrekt in der Gewinn- und Verlustrechnung und der skattemelding landet.',
  'buy.supplier': 'Lieferant',
  'buy.accountFromHistory': 'Aufwandskonto vorgeschlagen aus früheren Einkäufen bei diesem Lieferanten. Du kannst es in der Einkaufszeile ändern.',
  'buy.date': 'Kaufdatum',
  'buy.invoiceNumber': 'Rechnungsnummer',
  'buy.invoiceNumberPh': 'Z. B. 100245',
  'buy.dueDate': 'Fälligkeitsdatum',
  'buy.lines': 'Zeilen',
  'buy.linesHelp': 'Jede Zeile ist eine Kostenposition auf dem Beleg mit eigenem Betrag, MwSt.-Satz und eigener Kategorie. Hat die Quittung verschiedene Waren oder MwSt.-Sätze, legst du eine Zeile pro Art an. Du kannst die Zeilen ziehen, um die Reihenfolge zu ändern.',
  'buy.addLine': 'Zeile hinzufügen',
  'buy.payment': 'Zahlung',
  'buy.paymentHelp': 'Bei einer Lieferantenrechnung wählst du, ob die Rechnung bezahlt ist. Unbezahlte Rechnungen werden als offene Lieferantenverbindlichkeit gespeichert, damit die Zahlung später erfasst werden kann.',
  'buy.immediatePaymentHelp': 'Ein normaler Einkauf ist bereits bezahlt. Wähle, von welchem Konto bezahlt wurde und an welchem Datum.',
  'buy.paid': 'Bezahlt',
  'buy.unpaid': 'Nicht bezahlt',
  'buy.paidFrom': 'Bezahlt von',
  'buy.choosePaymentSource': 'Zahlungsquelle wählen',
  'buy.paidDate': 'Zahlungsdatum',
  'buy.paidDateHelp': 'Das Datum, an dem der Einkauf bezahlt wurde. Das Kaufdatum bestimmt den Buchungs- und MwSt.-Zeitraum des Einkaufs selbst.',
  'buy.dateLabel': 'Datum',
  'buy.addPartPayment': 'Teilzahlung hinzufügen',
  'buy.addPartPaymentHelp': 'Erfasse eine weitere Zahlung. Die Summe der Teilzahlungen wird vom Gesamtbetrag abgezogen - der Rest wird als „Offen“ angezeigt.',
  'buy.remaining': 'Offen',
  'buy.remainingHelp': 'Die Differenz zwischen dem Gesamtbetrag und den erfassten Teilzahlungen. Ist sie 0, ist der Einkauf vollständig beglichen.',
  'buy.preview': 'Vorschau',
  'buy.previewHelp': 'Vorschau des hochgeladenen Belegs. Hast du noch keinen Beleg hochgeladen, kannst du das hier tun.',
  'buy.dropReceiptLong': 'Quittung hier ablegen - zieh ein Bild oder PDF hinein oder tippe, um eine Datei auszuwählen.',
  'buy.summaryHelp': 'Die Zusammenfassung zeigt Netto, MwSt. und den Gesamtbetrag, den du bezahlst.',
  'buy.saveDraft': 'Entwurf speichern',
  'buy.saveDraftHelp': 'Speichert den Einkauf als Entwurf, ohne ihn zu buchen. Belege und Zahlungen werden erst als gebucht markiert, wenn du den Einkauf abschließt.',
  'buy.title': 'Bezahlter Einkauf',
  'buy.subtitle': 'Erfasse einen Einkauf - lade den Beleg hoch, wir schlagen den Rest vor.',
  'buy.drafts': 'Entwürfe',
  'buy.draftsSub': 'Begonnene Einkäufe und Vermögenswerte, die du noch nicht gebucht hast',
  'buy.draftsSearchPh': 'Lieferant, Beschreibung, Rechnungsnr. oder Betrag',
  'buy.showMore': 'Mehr anzeigen',
  'buy.noDrafts': 'Keine Entwürfe',
  'buy.invoiceNoShort': 'Rechnungsnr.',
  'buy.delete': 'Löschen',
  'buy.deleteDraftTitle': 'Entwurf löschen?',
  'buy.deleteDraftConfirm': 'Ja, Entwurf löschen',
  'buy.deleteDraftBody': 'Möchtest du den Entwurf wirklich löschen für',
  'buy.resetTitle': 'Formular zurücksetzen und neu beginnen',
  'buy.reset': 'Zurücksetzen',
  'buy.howRegister': 'Wie möchtest du den Einkauf erfassen?',
  'buy.howRegisterSub': 'Lade am besten zuerst den Beleg hoch - dann schlagen wir den Rest für dich vor.',
  'buy.stepByStep': 'Schritt für Schritt',
  'buy.stepByStepHelp': 'Führt dich Teil für Teil durch den Einkauf - zuerst Beleg, dann Datum, Zeilen und Zahlung. Gut, wenn du es ruhig angehen willst.',
  'buy.stepByStepShort': 'Zuerst der Beleg, dann Datum, Zeilen und Zahlung.',
  'buy.onePage': 'Alles auf einer Seite',
  'buy.onePageHelp': 'Zeigt das gesamte Einkaufsformular auf einer Seite. Gut, wenn du Einkäufe routiniert erfasst und alles vor dir haben willst.',
  'buy.onePageShort': 'Das gesamte Einkaufsformular auf einen Blick.',
  'buy.toSteps': 'Zu Schritt für Schritt wechseln',
  'buy.toOnePage': 'Zu alles auf einer Seite wechseln',
  'buy.back': 'Zurück',
  'buy.next': 'Weiter',
  'buy.backToVouchers': 'Zurück zu den Transaktionen',
  'buy.salesType': 'Verkaufsart',
  'buy.paidTo': 'Bezahlt an',
  'buy.payOperating': 'Geschäftskonto',
  'buy.payCash': 'Bar',
  'buy.payPrivate': 'Privat',
  'buy.whatSold': 'Was hast du verkauft?',
  'buy.amountExVat': 'Betrag exkl. MwSt.',
  'buy.amountIncVat': 'Betrag inkl. MwSt.',
  'buy.vatLabel': 'MwSt.',
  'buy.otherSale': 'Sonstiger Verkauf',
  'buy.invoiceOrQuote': 'Rechnung / Angebot',
  'buy.switchMode': 'Modus wechseln',
  'buy.moreOptions': 'Weitere Optionen',
  'buy.postAs': 'Buchen als',
  'buy.backendUploadNotReady': 'Der Backend-Upload ist nicht bereit.',
  'buy.multipleUploadedShowFirst': 'Es wurden mehrere Belege hochgeladen. Hier wird der erste angezeigt.',
  'buy.uploadFailed': 'Der Beleg konnte nicht hochgeladen werden.',
  'buy.dropReceiptTitle': 'Beleg hier ablegen',
  'buy.dropReceiptSubtitle': '...dann helfen wir dir, ihn richtig zuzuordnen. Zieh ein Bild oder PDF hierher oder tippe, um eine Datei zu wählen.',
  'buy.attachedCount': 'Verknüpfte Belege: {count}',
  'buy.uploading': 'Wird hochgeladen...',
  'buy.chooseFile': 'Datei wählen',
  'buy.dropToUpload': 'Beleg zum Hochladen ablegen',
  'buy.accountFallbackOperating': 'Geschäftskonto · 1920',
  'buy.accountFallbackCash': 'Bar',
  'buy.accountFallbackPrivate': 'Private Auslage',
  'buy.accountFallbackCash1900': 'Bar - 1900',
  'buy.accountFallbackPrivate2060': 'Privat - 2060',
  'buy.addSupplierQuery': '„{query}“ hinzufügen',
  'buy.chartNotConnected': 'Der Kontenplan ist nicht mit dem Speicher verbunden.',
  'buy.accountAdded': 'Das Konto wurde hinzugefügt.',
  'buy.accountSaveFailed': 'Das Konto konnte nicht gespeichert werden.',
  'buy.chooseAccount': 'Konto wählen',
  'buy.forQuery': 'für „{query}“',
  'buy.newCustomAccountTitle': 'Neues benutzerdefiniertes Konto',
  'buy.saving': 'Wird gespeichert...',
  'buy.saveAccount': 'Konto speichern',
  'buy.accountNamePlaceholder': 'z. B. Softwareentwicklung',
  'buy.accountHelperText': 'Das Konto wird in der Kontosuche verfügbar und für Berichte und den Jahresabschluss dem Standardkonto zugeordnet.',
  'buy.inventoryProduct': 'Lagerartikel',
  'buy.notTracked': 'Nicht lagergeführt',
  'buy.quantityInStock': 'Zugangsmenge ins Lager',
  'buy.inStockCount': '{n} auf Lager',
  'buy.inventoryLineToggle': 'Lagerführen',
  'buy.inventoryLineToggleHelp': 'Aktiviere dies, wenn der Einkauf den Bestand eines erfassten Lagerartikels erhöhen soll.',
  'buy.inventorySearchPlaceholder': 'Lagerartikel wählen',
  'buy.inventorySearch': 'Nach Name, Artikelnummer, SKU oder EAN suchen',
  'buy.inventorySearchEmpty': 'Keine lagergeführten Artikel passen zur Suche.',
  'buy.inventoryOpenProducts': 'Produkte öffnen',
  'buy.inventoryUnitsInStock': 'auf Lager',
  'inventoryPurchase.settingsTitle': 'Lagerführung bei Einkäufen',
  'inventoryPurchase.settingsHelp': 'Zeige ein optionales Lagerfeld auf Einkaufszeilen, damit ein Einkauf den Bestand eines erfassten Lagerartikels erhöhen kann.',
  'inventoryPurchase.offHelp': 'Das Lagerfeld ist bei neuen Einkäufen ausgeblendet. Produkte und frühere Lagerbewegungen bleiben erhalten.',
  'inventoryPurchase.migratedTitle': 'Lagerführung bei Einkäufen ist aktiviert',
  'inventoryPurchase.migratedText': 'Das Unternehmen hat bereits Produkte mit automatischer Lagerführung. Deshalb ist die Lagerverknüpfung auf Einkaufszeilen aktiviert, damit der bestehende Arbeitsablauf weiterläuft.',
  'inventoryPurchase.acknowledge': 'Verstanden',
  'inventoryPurchase.acknowledgeError': 'Die Bestätigung konnte nicht gespeichert werden.',
  'inventoryPurchase.openSettings': 'Einstellungen öffnen',
  'inventoryPurchase.disableTitle': 'Lagerführung bei Einkäufen deaktivieren?',
  'inventoryPurchase.disableConfirm': 'Deaktivieren',
  'inventoryPurchase.disableWarning': 'Das Lagerfeld wird bei neuen Einkäufen ausgeblendet. Einkäufe können dann nicht mehr mit lagergeführten Produkten verknüpft werden, und der Bestand kann falsch werden, wenn er nicht manuell geprüft und angepasst wird.',
  'inventoryPurchase.disableHistory': 'Bestehende Produkte und historische Lagerbewegungen werden nicht gelöscht. Zähle das Lager und erfasse notwendige Anpassungen manuell.',
  'inventoryPurchase.enabledLabel': 'Lagerführung bei Einkäufen',
  'inventoryPurchase.disabledLabel': 'Lagerführung bei Einkäufen',
  'buy.noDescription': 'Ohne Beschreibung',
  'buy.attachmentFallback': 'Beleg',
  'buy.lockVatTitle': 'Der MwSt.-Zeitraum ist gemeldet',
  'buy.lockYearTitle': 'Das Geschäftsjahr ist abgeschlossen',
  'buy.lockBankTitle': 'Die Bankperiode ist abgestimmt',
  'buy.lockVatTarget': 'den MwSt.-Zeitraum',
  'buy.lockYearTarget': 'den Jahresabschluss',
  'buy.lockBankTarget': 'die Bankabstimmung',
  'buy.lockWarningText': '{title}. Du kannst Beschreibung und Aufwandskonto/Kategorie des Einkaufs noch ändern, aber Einkaufsdatum, Betrag, MwSt.-Code und Zahlungsfelder sind gesperrt. Öffne oder korrigiere {target}, wenn du diese Felder ändern musst.',
  'buy.lockVatWarningText': '{title}. Einkaufsdatum, Betrag und MwSt.-Code sind gesperrt, aber Beschreibung, Aufwandskonto/Kategorie und Zahlungskonto können noch korrigiert werden. Öffne oder korrigiere {target}, wenn die MwSt.-Grundlage geändert werden muss.',
  'buy.backendSaveNotReady': 'Das Speichern im Backend ist nicht bereit.',
  'buy.needAtLeastOneLine': 'Füge mindestens eine Einkaufszeile hinzu.',
  'buy.needDescriptionAllLines': 'Gib für alle Zeilen eine Beschreibung ein, bevor du buchst.',
  'buy.needContentForDraft': 'Füge eine Zeile, einen Lieferanten oder einen Beleg hinzu, bevor du den Entwurf speicherst.',
  'buy.needSupplierForInvoice': 'Wähle einen Lieferanten oder gib einen Lieferantennamen ein, bevor du die Teilzahlung/Lieferantenrechnung speicherst.',
  'buy.draftSaved': 'Entwurf gespeichert.',
  'buy.attachmentUpdated': 'Der Beleg wurde aktualisiert.',
  'buy.invoiceRegisteredOpen': 'Rechnung als offene Lieferantenrechnung erfasst.',
  'buy.purchaseBooked': 'Einkauf gebucht! Der Beleg liegt jetzt unter Transaktionen.',
  'buy.purchaseSaveFailed': 'Der Einkauf konnte nicht gespeichert werden.',
  'buy.docsFetchedFromInbox': 'Aus dem Posteingang abgerufene Belege: {count}',
  'buy.fullPayment': 'Vollständige Zahlung',
  'buy.partPayment': 'Teilzahlung',
  'buy.partPaymentWarning': 'Eine Teilzahlung wird als Lieferantenrechnung erfasst. Der Rest wird bis zur Zahlung als Lieferantenverbindlichkeit auf 2400 gebucht.',
  'buy.partPaymentLabel': 'Teilzahlung {n}',
  'buy.remainingSuffix': '· offen',
  'buy.unpaidWillBeInvoice': 'Ohne erfasste Zahlung wird dies als offene Lieferantenrechnung gespeichert. Du kannst die Zahlung später erfassen.',
  'buy.forgotReceiptTitle': 'Beleg vergessen?',
  'buy.registerInvoice': 'Rechnung erfassen',
  'buy.bookPurchase': 'Einkauf buchen',
  'buy.registerInvoiceHelp': 'Speichert die Rechnung als offene Lieferantenverbindlichkeit. Sie erscheint beim Lieferanten, und du erfasst die Zahlung, sobald sie bezahlt ist.',
  'buy.bookPurchaseHelp': 'Speichert den Einkauf in der Buchhaltung. Der Beleg landet unter „Transaktionen“, und die Beträge werden auf die richtigen Konten gebucht.',
  'buy.typeBadgeInvoice': 'Rechnung',
  'buy.typeBadgeAsset': 'Anlagegut',
  'buy.draftDeleteNotConnected': 'Das Löschen von Entwürfen ist nicht mit dem Backend verbunden.',
  'buy.draftDeleted': 'Entwurf gelöscht.',
  'buy.draftDeleteFailed': 'Der Entwurf konnte nicht gelöscht werden.',
  'buy.pageHelpDrafts': 'Hier erfasst du alles, was das Unternehmen einkauft. Wähle „Entwürfe“ im Dropdown-Menü, um begonnene Einkäufe zu sehen, die du noch nicht gebucht hast.',
  'buy.draftsPageHelp': 'Einkäufe, die du begonnen, aber nicht abgeschlossen hast, werden hier gespeichert. Öffne einen Entwurf, um weiterzumachen, oder lösche, was du nicht brauchst.',
  'buy.viewOptionsLabel': 'Anzeigeoptionen',
  'buy.assetsLabel': 'Anlagegüter',
  'buy.noDraftsMatchSearch': 'Keine Entwürfe passen zur Suche.',
  'buy.draftsEmptyHint': 'Begonnene Einkäufe, die du als Entwurf speicherst, erscheinen hier.',
  'buy.colSupplier': 'Lieferant',
  'buy.noSupplier': 'Ohne Lieferant',
  'buy.colType': 'Art',
  'buy.colInvoiceNo': 'Rechnungsnr.',
  'buy.colDate': 'Datum',
  'buy.colAmount': 'Betrag',
  'buy.thisPurchaseFallback': 'diesen Einkauf',
  'buy.cannotBeUndone': '? Dies kann nicht rückgängig gemacht werden.',
  'buy.formReset': 'Das Formular wurde zurückgesetzt',
  'buy.editPurchaseSubtitle': 'Aktualisiere den Beleg und speichere die Änderungen im Backend.',
  'buy.newPurchasePageHelp': 'Hier erfasst du alles, was das Unternehmen einkauft - Waren, Ausstattung, Abonnements, Reisen. Lade den Beleg hoch, dann liest SuperPlumma die Details aus und bucht die Kosten mit der richtigen MwSt. auf das richtige Konto.',
  'buy.defaultLineDescription': 'Einkauf',
  'buy.customerFallback': 'Kunde',
  'buy.supplierAndDateTitle': 'Lieferant und Datum',
  'buy.supplierAndDateInvoiceHelp': 'Bei wem du gekauft hast und wann. Das Rechnungsdatum ist das Datum auf der Rechnung, und das Fälligkeitsdatum ist der Zeitpunkt, zu dem sie bezahlt werden muss. Die Rechnungsnummer ist die eigene Nummer des Lieferanten auf der Rechnung.',
  'buy.supplierAndDatePurchaseHelp': 'Das Einkaufsdatum bestimmt, in welche Buchhaltungs- und MwSt.-Periode der Einkauf fällt. Verwende das Datum auf dem Beleg.',
  'buy.katFixedAssets': 'Anlagegüter / Ausstattung',
  'buy.katRent': 'Miete',
  'buy.katPhoneInternet': 'Telefon und Internet',
  'buy.katSoftware': 'Software / Abonnement',
  'buy.katTravel': 'Reise und Verpflegung',
  'buy.katRepresentation': 'Bewirtung',
  'buy.acct4000': 'Rohstoffe und Halbfabrikate',
  'buy.acct4300': 'Wareneinkauf für den Wiederverkauf',
  'buy.acct4500': 'Fremdleistungen und Subunternehmer',
  'buy.acct5000': 'Löhne an Mitarbeiter',
  'buy.acct5400': 'Arbeitgeberabgabe',
  'buy.acct5900': 'Geschenke an Mitarbeiter',
  'buy.acct6000': 'Abschreibungen',
  'buy.acct6100': 'Fracht- und Transportkosten',
  'buy.acct6200': 'Energie, Strom und Heizung',
  'buy.acct6300': 'Miete Geschäftsräume',
  'buy.acct6320': 'Müllabfuhr, Wasser, Abwasser usw.',
  'buy.acct6340': 'Licht, Heizung',
  'buy.acct6360': 'Reinigung',
  'buy.acct6400': 'Miete Maschinen',
  'buy.acct6500': 'Werkzeuge und Inventar',
  'buy.acct6540': 'Inventar und Ausstattung',
  'buy.acct6550': 'Betriebsstoffe',
  'buy.acct6560': 'Verbrauchsmaterial',
  'buy.acct6600': 'Reparatur und Instandhaltung Gebäude',
  'buy.acct6690': 'Reparatur und Instandhaltung Sonstiges',
  'buy.acct6700': 'Prüfung und Buchhaltung',
  'buy.acct6720': 'Rechtsberatung',
  'buy.acct6790': 'Sonstige Fremdleistungen',
  'buy.acct6800': 'Büromaterial',
  'buy.acct6810': 'IT-/EDV-Kosten',
  'buy.acct6820': 'Drucksachen',
  'buy.acct6900': 'Telefon',
  'buy.acct6940': 'Porto',
  'buy.acct7000': 'Kraftstoff Fahrzeuge',
  'buy.acct7020': 'Wartung Auto',
  'buy.acct7040': 'Versicherung und Abgaben Fahrzeuge',
  'buy.acct7100': 'Kilometergeld',
  'buy.acct7140': 'Reisekosten, nicht meldepflichtig',
  'buy.acct7150': 'Verpflegungskosten',
  'buy.acct7160': 'Reisekosten, meldepflichtig',
  'buy.acct7300': 'Vertriebskosten',
  'buy.acct7320': 'Werbung und Anzeigen',
  'buy.acct7350': 'Bewirtung, abzugsfähig',
  'buy.acct7360': 'Bewirtung, nicht abzugsfähig',
  'buy.acct7400': 'Mitgliedsbeiträge',
  'buy.acct7500': 'Versicherungsprämie',
  'buy.acct7600': 'Lizenz, Patent und Lizenzgebühren',
  'buy.acct7700': 'Sonstige Betriebskosten',
  'buy.acct7770': 'Bank- und Kartengebühren',
  'buy.acct7790': 'Sonstige Kosten',
  'buy.acct8050': 'Zinserträge',
  'buy.acct8150': 'Zinsaufwand',
  'buy.acct8300': 'Zu zahlende Steuer',
  'buy.fallbackCostName': 'Kosten',
  'buy.fallbackAccountName': 'Konto',
  'buy.grp40': 'Materialaufwand',
  'buy.grp43': 'Handelswaren',
  'buy.grp45': 'Eingekaufte Leistungen',
  'buy.grp50': 'Lohn',
  'buy.grp54': 'Arbeitgeberabgabe',
  'buy.grp59': 'Personalkosten',
  'buy.grp60': 'Abschreibungen',
  'buy.grp61': 'Fracht und Transport',
  'buy.grp62': 'Energie und Heizung',
  'buy.grp63': 'Geschäftsräume',
  'buy.grp64': 'Miete Maschinen und Ausstattung',
  'buy.grp65': 'Werkzeuge und Inventar',
  'buy.grp66': 'Reparatur und Instandhaltung',
  'buy.grp67': 'Fremdleistungen',
  'buy.grp68': 'Bürokosten',
  'buy.grp69': 'Telefon, Porto usw.',
  'buy.grp70': 'Fahrzeuge',
  'buy.grp71': 'Reise und Verpflegung',
  'buy.grp73': 'Vertrieb und Bewirtung',
  'buy.grp74': 'Mitgliedsbeiträge',
  'buy.grp75': 'Versicherung',
  'buy.grp76': 'Lizenz und Lizenzgebühren',
  'buy.grp77': 'Sonstige Betriebskosten',
  'buy.grp15': 'Kurzfristige Forderungen',
  'buy.grp24': 'Verbindlichkeiten aus Lieferungen',
  'buy.groupAssets': 'Vermögenswerte',
  'buy.groupEquityAndLiabilities': 'Eigenkapital und Verbindlichkeiten',
  'buy.groupIncome': 'Erträge',
  'buy.groupCostOfGoods': 'Materialaufwand',
  'buy.groupPayrollAndPersonnel': 'Lohn- und Personalkosten',
  'buy.groupOtherOperating': 'Sonstige Betriebskosten',
  'buy.groupFinanceAndTax': 'Finanzen und Steuern',
  'buy.groupAccountsFallback': 'Konten',
  'rep.trial.onlyMovement': 'Nur Konten mit Bewegung anzeigen',
  'rep.trial.showInactive': 'Auch inaktive Konten anzeigen',
  'rep.trial.payrollLiability': 'Geschuldeter Lohn',
  'rep.trial.holidayPayLiability': 'Geschuldetes Urlaubsgeld',
  'rep.trial.oneEmployee': '{n} Mitarbeiter',
  'rep.trial.employeeCount': '{n} Mitarbeiter',
  'rep.trial.otherPayrollLiability': 'Alle Buchungen auf 2930',
  'rep.trial.allAccountEntries': 'Alle Buchungen auf {account}',
  'rep.trial.payrollRun': 'Lohnlauf {period}',
  'rep.trial.term': '{term}. Zeitraum {year}',
  'rep.trial.accrualYear': 'Erwerbsjahr {year}',
  'vehiclePolicy.dialogTitle': 'Fahrzeug und Fahrzeugkosten',
  'vehiclePolicy.intro': 'Wähle, wie Plumme Kraftstoff, Werkstatt und andere eindeutige Fahrzeugkosten behandeln soll. Dies ist eine Arbeitseinstellung für Belegvorschläge und erfasst kein Fahrzeug als Vermögenswert.',
  'vehiclePolicy.optionVat': 'Fahrzeug mit MwSt.-Abzug',
  'vehiclePolicy.optionVatSub': 'Das Unternehmen besitzt oder least das Fahrzeug, der Fahrzeugtyp berechtigt zum Abzug, und die Kosten betreffen eine registrierte MwSt.-pflichtige Tätigkeit.',
  'vehiclePolicy.optionNoVat': 'Fahrzeug ohne MwSt.-Abzug',
  'vehiclePolicy.optionNoVatSub': 'Fahrzeugkosten ohne Vorsteuerabzug vorschlagen.',
  'vehiclePolicy.optionManual': 'Jeden Beleg manuell prüfen',
  'vehiclePolicy.optionManualSub': 'Plumme schlägt das Konto vor, lässt den MwSt.-Abzug aber zur Prüfung offen.',
  'vehiclePolicy.validFrom': 'Gültig ab',
  'vehiclePolicy.noEndDateWarning': 'Ohne Enddatum gilt die Auswahl, bis du sie änderst. Eine neue Auswahl beendet die vorherige automatisch ab dem Änderungsdatum.',
  'vehiclePolicy.responsibility': 'Ich bestätige, dass die Angabe richtig ist, und verstehe, dass ich sie selbst aktualisieren muss, wenn das Fahrzeug verkauft wird, der Leasingvertrag endet oder sich Fahrzeugtyp oder Nutzung ändern.',
  'vehiclePolicy.receiptTitle': 'Fahrzeug einmal klären',
  'vehiclePolicy.receiptText': 'Dann erhalten spätere Kraftstoff- und Werkstattbelege automatisch den richtigen MwSt.-Vorschlag.',
  'vehiclePolicy.changeFromReceiptTitle': 'Fahrzeugregel ändern?',
  'vehiclePolicy.changeFromReceiptText': 'Du hast diesen Fahrzeugbeleg auf 0 % MwSt.-Abzug gesetzt. Soll das nur für diesen Beleg gelten, oder soll Plumme Fahrzeugkosten künftig ohne MwSt.-Abzug behandeln, weil das Fahrzeug verkauft, das Leasing beendet oder das Abzugsrecht nicht mehr gegeben ist?',
  'vehiclePolicy.changeFromReceiptDate': 'Die neue Regel gilt ab {date}.',
  'vehiclePolicy.receiptOnly': 'Nur dieser Beleg',
  'vehiclePolicy.updateToNoVat': 'Künftig 0 % verwenden',
  'vehiclePolicy.settingsTitle': 'Fahrzeug und Fahrzeugkosten',
  'vehiclePolicy.settingsText': 'Steuert automatische Vorschläge für Kraftstoff, Werkstatt und andere eindeutige Fahrzeugkosten. Die Einstellung bucht nichts und legt weder einen Vermögenswert noch einen Leasingvertrag an.',
  'vehiclePolicy.choose': 'Einstellung wählen',
  'vehiclePolicy.change': 'Einstellung ändern',
  'vehiclePolicy.save': 'Speichern und anwenden',
  'vehiclePolicy.saved': 'Die Fahrzeugeinstellung wurde gespeichert.',
  'vehiclePolicy.saveError': 'Die Fahrzeugeinstellung konnte nicht gespeichert werden.',
  'vehiclePolicy.chooseError': 'Wähle, wie Fahrzeugbelege behandelt werden sollen.',
  'vehiclePolicy.confirmError': 'Bestätige, dass das Unternehmen die Angabe selbst aktuell hält.',
  'vehiclePolicy.notConfigured': 'Nicht konfiguriert – Fahrzeugbelege müssen geprüft werden',
  'vehiclePolicy.activeFrom': 'Gültig ab',
  'vehiclePolicy.noEndDate': 'kein Enddatum',
  'vehiclePolicy.mode.vat_deductible': 'Fahrzeug mit MwSt.-Abzug',
  'vehiclePolicy.mode.no_vat_deduction': 'Fahrzeug ohne MwSt.-Abzug',
  'vehiclePolicy.mode.manual_review': 'Manuelle Prüfung jedes Belegs',
  'buy.vatDeduction': 'Vorsteuerabzug',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Teilweise',
  'buy.vatDeductionPercent': 'Abzugsprozentsatz',
  'buy.fixedAssetLine': 'Zeile als Anlagegut erfassen',
  'buy.fixedAssetLineHelp': 'Die Zeile wird in das Anlagenverzeichnis aufgenommen, statt nur als Kosten behandelt zu werden.',
  'buy.fixedAssetFallback': 'Anlagegut',
  'buy.projectForLine': 'Projekt für diese Zeile',
  'sup.credit.created': 'Die Lieferantengutschrift wurde gebucht.',
  'sup.credit.refunded': 'Die Erstattung wurde gebucht.',
  'sup.credit.title': 'Lieferantengutschrift erfassen',
  'sup.credit.refundTitle': 'Erstattung der Gutschrift erfassen',
  'sup.credit.action': 'Gutschrift buchen',
  'sup.credit.refundAction': 'Erstattung erfassen',
});
